import { render, staticRenderFns } from "./TheFooterTabsMobile.vue?vue&type=template&id=770b9cb2&"
import script from "./TheFooterTabsMobile.vue?vue&type=script&lang=js&"
export * from "./TheFooterTabsMobile.vue?vue&type=script&lang=js&"
import style0 from "./TheFooterTabsMobile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports